import { useState } from 'react';

import { pluralize } from '@/portainer/helpers/strings';

import { Modal, OnSubmit, ModalType, openModal } from '@@/modals';
import { Button } from '@@/buttons';
import { SwitchField } from '@@/form-components/SwitchField';

import { Environment } from '../types';

interface Props {
  onSubmit: OnSubmit<{ deleteClusters: boolean; confirmed: boolean }>;
  environmentsToDelete: Environment[];
}

function ConfirmDeleteEnvironmentsModal({
  onSubmit,
  environmentsToDelete,
}: Props) {
  const [deleteClusters, setDeleteClusters] = useState(false);
  const hasCloudProvider = environmentsToDelete.some((e) => e.CloudProvider);

  return (
    <Modal
      onDismiss={() => onSubmit()}
      aria-label="confirm delete environment modal"
    >
      <Modal.Header title="Are you sure?" modalType={ModalType.Destructive} />

      <Modal.Body>
        <p>
          Are you sure you want to disconnect{' '}
          <b>{environmentsToDelete.length}</b>{' '}
          {pluralize(environmentsToDelete.length, 'environment')} and remove
          their configurations from Portainer?
        </p>
        {hasCloudProvider && (
          <SwitchField
            name="deleteClusters"
            data-cy="delete-environments-delete-cluster-switch"
            label="Also delete the remote cluster(s) provisioned for these environments"
            checked={deleteClusters}
            onChange={setDeleteClusters}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onSubmit()}
          data-cy="cancel-delete-environments-button"
          color="default"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit({ deleteClusters, confirmed: true })}
          data-cy="confirm-delete-environments-button"
          color="danger"
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export async function confirmDeleteEnvironments(
  environmentsToDelete: Environment[]
) {
  return openModal(ConfirmDeleteEnvironmentsModal, {
    environmentsToDelete,
  });
}
